export default __webpack_public_path__ + "static/media/detail_mobile_14_2.e50490e1.jpg";